export default __webpack_public_path__ + "scripts/resource/8c113a97cb9cda83e7d72b1c5cd73e5a.svg";